<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.2002 2.5H16.7998C18.2944 2.5 19.4579 2.96466 20.2451 3.75293C20.983 4.49184 21.4354 5.56024 21.4854 6.92188L21.4902 7.19824V16.7998C21.4902 18.2943 21.0249 19.4575 20.2363 20.2461C19.4477 21.0347 18.2846 21.5 16.79 21.5H14.2002C12.7056 21.5 11.5425 21.0347 10.7539 20.2461C9.96528 19.4575 9.5 18.2944 9.5 16.7998V13.25H15.25C15.9361 13.25 16.5 12.6861 16.5 12C16.5 11.3139 15.9361 10.75 15.25 10.75H9.5V7.2002C9.5 5.70564 9.96528 4.54253 10.7539 3.75391C11.5425 2.96528 12.7056 2.5 14.2002 2.5Z"
    [attr.fill]="color"
    stroke="black"
  />
  <path
    d="M5.92285 8.47382C6.01759 8.37908 6.18163 8.37908 6.27637 8.47382L6.28809 8.48553C6.32043 8.51573 6.3495 8.57444 6.34961 8.6496C6.34961 8.69808 6.33658 8.74456 6.30859 8.78632L6.27637 8.82635L3.35254 11.7502H8.49902V12.2502H3.35254L6.27637 15.174C6.35899 15.2571 6.36905 15.3926 6.30664 15.4885L6.27637 15.5266C6.19359 15.6093 6.05793 15.6197 5.96191 15.5578L5.92285 15.5266L2.57324 12.1769C2.49042 12.0941 2.48001 11.9585 2.54199 11.8625L2.57324 11.8234L5.92285 8.47382Z"
    [attr.fill]="color"
    stroke="black"
  />
</svg>
